import React from "react";
import { useImperativeHandle } from "react";

import { useTranslation } from "react-i18next";

const ProfessionPicker = ({}, ref) => {
  const { t } = useTranslation();
  const [selectValue, setSelectValue] = React.useState(1);
  const onChange = (event) => {
    const value = event.target.value;
    setSelectValue(value);
    console.log(event.target.value);
  };
  useImperativeHandle(ref, () => ({
    getData: getData,
  }));
  const getData = () => {
    return selectValue;
  };
  return (
    <div>
      <label class="form-label" for="grid-Job">
        {t("Job")}
      </label>
      <select class="form-select" id="grid-Job" name="grid-Job" onChange={onChange} defaultValue={selectValue}>
        <option value="0">---</option>
        <option value="1">{t("Progettista")}</option>
        <option value="2">{t("StudioTecnico")}</option>
        <option value="3">{t("Architetto")}</option>
        <option value="4">{t("Ingegnere")}</option>
        <option value="5">{t("Geometra")}</option>
        <option value="6">{t("Termotecnico")}</option>
        <option value="7">{t("ResponsabileSicurezza")}</option>
        <option value="8">{t("RivenditaMaterialiEdili")}</option>
        <option value="9">{t("CarpenteriaLegno")}</option>
        <option value="10">{t("Carpenterie")}</option>
        <option value="11">{t("Lattoneria")}</option>
        <option value="12">{t("Serramentista")}</option>
        <option value="13">{t("ImpresaEdile")}</option>
        <option value="14">{t("EntePubblico")}</option>
        <option value="15">{t("StudenteProfessore")}</option>
        <option value="16">{t("Altro")}</option>
      </select>
    </div>
  );
};

export default React.forwardRef(ProfessionPicker);
